import { useSelector } from "react-redux";
import MyNotificationsPopUp from "./index";

function MyNotificationWrapper() {
  const { showMyNotificationsPopUp } = useSelector((state) => state.login);

  return <div>{showMyNotificationsPopUp && <MyNotificationsPopUp />}</div>;
}

export default MyNotificationWrapper;
